
export const AuthAlternanca = ({auth, handleChange, error }) => 
{
  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4> Compromís i acceptació de les condicions de la formació en alternança </h4>
        <h5> Informació per a l’alumne/a </h5>
        <ol>
          <li>El centre docent ofereix el cicle formatiu en la modalitat d’alternança indicada, d’acord amb la Resolució 2085/2020, de 20 d’agost,per la qual s'actualitza l'organització de la formació en alternança en els ensenyaments de formació professional inicial.</li>
          <li>La formació en alternança dual permet fer una estada remunerada en una empresa, a través de la qual poden ser avaluades ireconegudes acadèmicament, els aprenentatges assolits.</li>
          <li>Aquesta formació comporta compatibilitzar les classes al centre educatiu amb l’estada a l’empresa a través d’una beca o d’un contracte laboral.</li>
          <li>La convalidació d’unitats formatives, crèdits o mòduls professionals del cicle formatiu en cap cas implica una reducció de les hores de l’estada en l’empresa.</li>
          <li>Si, per circumstàncies imprevistes, les empreses participants no poden complir els acords subscrits amb la titularitat del centre,aquestes queden eximides de qualsevol responsabilitat.</li>
        </ol>

        <h5> Declaració de l’alumne/a </h5>
        Declaro que estic informat:
        <ul>
          <li>de les característiques de desenvolupament de la formació en alternança;</li>
          <li>que la matriculació en la modalitat de formació en alternança no garanteix la realització de l’estada formativa en l’empresa amb beca d’empresa o contracte laboral.</li>
          <li>que el centre educatiu pot condicionar la proposta de la meva incorporació i continuïtat a l’entitat en funció del meu rendimentacadèmic o de la meva actitud;</li>
          <li>que l’entitat pot interrompre l’estada formativa, amb comunicació prèvia a les persones responsables del centre educatiu i d’acord ambla normativa vigent.</li>
        </ul>
        <p>
          <input type="checkbox" id="authAlternanca" name="authAlternanca" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authAlternanca"> AUTORITZO  al centre educatiu i l’entitat formadora perquè es comuniquin mútuament les dades personals necessàries per tramitar i gestionar l’acord formatiu.  </label>
          <span id="auhtAlternanca_ERROR" className="a-Form-error">{error}</span>
        </p>
      </div>
    </div>
    <br />
  </>
  )
}